// extracted by mini-css-extract-plugin
module.exports = {"CompanyNature":"index-module_CompanyNature_3P98S"};